import { React, useEffect, useState } from "react";
import {
    Autocomplete,
    Button,
    Grid,
    TextField,
    Typography,
    Box,
    Card,
    CardContent,
    Stack,
    IconButton,
    Tooltip,
    Avatar,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import VerifiedIcon from "@mui/icons-material/Verified";
import { CustomSwitch } from "../../Assets/customTheme/customswitch";
import { MyVerifiedIcon, MyPersonIcon } from "../../Assets/svg/MyIcons";
import { verifyDomain, getBusinessType } from "../../Actions/OrganizationAction";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";

const OrganizationInfoStep = ({
    formik,
    qbotDomain,
    countryData,
    stateData,
    getStateData,
    dateFormatOptions,
    handleDateFormatChange,
    organizationDataById = null,
    timeFormatOptions,
    handleTimeFormatChange,
    handleTimeZoneChange,
    timeZone,
    businessType,
    getBusinessStateDate,
    businessStateData,
    isPaycentralEdit,
    setIsPaycentralEdit,
    isTrialPortalCreation
}) => {
    const [isVerified, setIsVerified] = useState(false);
    const [hasCustomDomain, setHasCustomDomain] = useState(false);
    const [isImageEdited, setIsImageEdited] = useState(false);

    const [isEditing, setIsEditing] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [buttonColor, setButtonColor] = useState("");
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const isEditMode = organizationDataById;

    const handleFileChange = (event) => {
        setIsImageEdited(true);
        formik.setFieldValue(
            "organizationLogo",
            event.currentTarget.files[0]
        );

        if (event.currentTarget.files && event.currentTarget.files[0]) {
            const reader = new FileReader();
            reader.onload = (e) => {
                formik.setFieldValue(
                    "imagePreview",
                    e.target.result
                );
            };
            reader.readAsDataURL(event.currentTarget.files[0]);
            setIsPaycentralEdit(true);
        }
    };

    const extractSubdomain = (domainUrl) => {
        const baseDomain = "netcluesdemo.com";
        if (!domainUrl) return "";
        return domainUrl
            .replace(/^https?:\/\//i, "") // Remove protocol
            .replace(`.${baseDomain}`, "") // Remove base domain
            .trim();
    };

    const handleEditClick = () => {
        setButtonColor("error");
        setIsVerified(false);
        setIsEditing(true);
        setHasCustomDomain(false);
        const currentDomain = formik.values.domainUrl;
        const subdomain = extractSubdomain(
            currentDomain
        );
        formik.setFieldValue("domainUrl", subdomain);

        formik.setFieldValue("isVerified", false);
        setIsButtonDisabled(true);
    };

    const generateDefaultDomainUrl = (subdomain) => {
        const baseDomain = "netcluesdemo.com";
        if (!subdomain) return "";
        const cleanSubdomain = subdomain
            .replace(/\s+/g, "") // Remove spaces
            .replace(/[^a-zA-Z0-9]/g, "") // Remove special characters
            .toLowerCase(); // Convert to lowercase
        return `https://${cleanSubdomain}.${baseDomain}`;
    };

    const handleSaveDomainUrl = () => {
        const subdomain = formik.values.domainUrl.trim();
        const defaultDomainUrl = generateDefaultDomainUrl(
            formik.values.userName
        );

        // Generate the full domain URL from the edited subdomain
        const updatedDomainUrl = generateDefaultDomainUrl(subdomain);

        // Validate the domain URL format
        const domainUrlRegex =
            /^(https?:\/\/)?([a-zA-Z0-9._-]+(\.[a-zA-Z]{2,}))$/;
        if (!domainUrlRegex.test(updatedDomainUrl)) {
            formik.setFieldError(
                "domainUrl",
                "Domain URL contains invalid characters. Only letters, numbers, periods, and hyphens are allowed."
            );
            return;
        }

        // Update the formik value with the full domain URL
        formik.setFieldValue("domainUrl", updatedDomainUrl);
        setIsEditing(false);
        // setIsButtonDisabled(false);
        setHasCustomDomain(true);
    };

    // useEffect(() => {
    //     if (formik.values.isVerified) return;
    //     if (!hasCustomDomain && formik.values.userName) {
    //         const generatedUrl = generateDefaultDomainUrl(
    //             formik.values.userName
    //         );
    //         if (formik.values.domainUrl !== generatedUrl) {
    //             formik.setFieldValue("domainUrl", generatedUrl);
    //         }
    //     }
    // }, [formik.values.userName]);

    useEffect(() => {
        if (
            !hasCustomDomain &&
            formik.values.userName &&
            (!organizationDataById || isTrialPortalCreation)
        ) {
            const generatedUrl = generateDefaultDomainUrl(
                formik.values.userName
            );

            if (formik.values.domainUrl !== generatedUrl) {
                formik.setFieldValue("domainUrl", generatedUrl);
            }
        }
    }, [
        formik.values.userName,
        organizationDataById,
        isTrialPortalCreation
    ]);

    // useEffect(() => {
    //     if (organizationDataById) {
    //         setIsEditing(false);
    //     }
    // }, [organizationDataById]);

    useEffect(() => {
        if (organizationDataById && !isTrialPortalCreation) {
            setIsEditing(false);
        }
    }, [organizationDataById, isTrialPortalCreation]);

    const verifyDomainURL = async () => {
        try {
            const paycentralDomain = formik?.values?.domainUrl?.trim()?.toLowerCase()?.replace(/^https?:\/\//, "");;
            const qbotDomainValue = qbotDomain?.values?.domainUrl?.trim()?.toLowerCase()?.replace(/^https?:\/\//, "");;

            if (
                qbotDomainValue &&
                paycentralDomain &&
                qbotDomainValue === paycentralDomain
            ) {
                formik.setFieldError(
                    "domainUrl",
                    "QBOT and PayCentral domains cannot be the same."
                );
                return;
            }

            const response = await verifyDomain({
                domainUrl: `${formik?.values?.domainUrl}`,
            });
            if (response.data.status === 200) {
                setSnackbar({
                    open: true,
                    message: response.data.message,
                    severity: "error",
                });
                setButtonColor("error");
                setIsVerified(false);
                setIsButtonDisabled(false);
            } else if (response.data.status === 202) {
                setButtonColor("success");
                setIsVerified(true);
                setIsButtonDisabled(true);
                formik.setFieldValue("isVerified", true);
            }
        } catch (error) {
            setSnackbar({
                open: true,
                message: error.response.data.message,
                severity: "error",
            });
            setIsButtonDisabled(false);
        }
    };

    useEffect(() => {
        if (formik.values.isVerified) {
            setButtonColor("success");
            setIsButtonDisabled(true);
        }
    }, [formik.values.isVerified]);

    useEffect(() => {
        if (!organizationDataById) return;

        const loadStates = async () => {

            // Business Country states
            if (organizationDataById.businessCountry) {
                await getBusinessStateDate(organizationDataById.businessCountry);
                formik.setFieldValue(
                    "businessState",
                    organizationDataById.businessState || ""
                );
            }

            // Organization Country states
            if (organizationDataById.country) {
                await getStateData(organizationDataById.country);
                formik.setFieldValue(
                    "state",
                    organizationDataById.state || ""
                );
            }
        };

        loadStates();
    }, [organizationDataById]);

    useEffect(() => {
        if (formik.values.businessCountry) {
            getBusinessStateDate(formik.values.businessCountry);
        }
    }, [formik.values.businessCountry]);

    useEffect(() => {

        if (!qbotDomain.values?.companyName || !formik.values.userName) return;

        const clean = (value) =>
            value?.trim().toLowerCase().replace(/[^a-zA-Z0-9]/g, "");

        const paycentralUserName = clean(formik.values.userName);
        const qbotCompanyName = clean(qbotDomain.values.companyName);

        if (paycentralUserName === qbotCompanyName) {
            formik.setFieldError(
                "userName",
                "QBOT company name and PayCentral user name cannot be the same."
            );
        }

    }, [formik.values.userName, qbotDomain?.values?.companyName]);

    return (
        <>
            {/* Form */}
            <Grid container spacing={3}>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="User Name"
                        name="userName"
                        value={formik.values.userName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.userName &&
                            Boolean(formik.errors.userName)
                        }
                        helperText={
                            formik.touched.userName && formik.errors.userName
                        }
                        disabled={Boolean(organizationDataById) && !isTrialPortalCreation}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Corporation Name"
                        name="organizationName"
                        value={formik.values.organizationName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.organizationName && Boolean(formik.errors.organizationName)}
                        helperText={formik.touched.organizationName && formik.errors.organizationName}
                    />
                </Grid>

                {(formik.values.userName || formik.values.domainUrl || !organizationDataById || isTrialPortalCreation) && (
                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" gutterBottom>
                            Domain
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 1.25,
                            }}
                        >
                            {/* Domain Input */}
                            <Box sx={{ flex: 1 }}>
                                <TextField
                                    name="domainUrl"
                                    type="text"
                                    size="small"
                                    fullWidth
                                    value={formik.values.domainUrl}
                                    onChange={(e) => {
                                        if (isEditing) {
                                            formik.setFieldValue("domainUrl", e.target.value);
                                            formik.setFieldValue("isVerified", false);
                                            setIsButtonDisabled(false);
                                            setButtonColor("");
                                        }
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.domainUrl && Boolean(formik.errors.domainUrl)}
                                    helperText={formik.touched.domainUrl && formik.errors.domainUrl}
                                    disabled={!isEditing || (Boolean(organizationDataById) && !isTrialPortalCreation)}
                                    placeholder={isEditing ? "Enter subdomain" : ""}
                                />
                            </Box>

                            {/* Action Buttons */}
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                {isEditing ? (
                                    <Tooltip title="Save">
                                        <IconButton
                                            className="text-success border border-success"
                                            type="button"
                                            onClick={handleSaveDomainUrl}
                                        >
                                            <SaveIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                ) : (
                                    <>
                                            {(!isEditMode || isTrialPortalCreation) && (
                                            <Tooltip title="Edit">
                                                <span
                                                    style={{
                                                        cursor: !formik.values.domainUrl ? "not-allowed" : "pointer",
                                                    }}
                                                >
                                                    <IconButton
                                                        className="text-primary border border-primary"
                                                        type="button"
                                                        onClick={handleEditClick}
                                                        disabled={!formik.values.domainUrl}
                                                        sx={{ "&.Mui-disabled": { opacity: 0.5 } }}
                                                    >
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        )}

                                        {/* Verify / Verified Button */}
                                        {!isEditing && (
                                            <Tooltip title={formik.values.isVerified ? "Verified" : "Verify Domain"}>
                                                <span
                                                    style={{
                                                            cursor: (!isEditing &&
                                                                Boolean(organizationDataById) &&
                                                                !isTrialPortalCreation) || formik.values.isVerified
                                                            ? "not-allowed"
                                                            : "pointer",
                                                    }}
                                                >
                                                    <IconButton
                                                        className={
                                                            buttonColor === "success" || formik.values.isVerified
                                                                ? "text-success border border-success"
                                                                : buttonColor === "error"
                                                                    ? "text-danger border border-danger"
                                                                    : "text-primary border border-primary"
                                                        }
                                                        onClick={verifyDomainURL}
                                                            disabled={(!isEditing &&
                                                                Boolean(organizationDataById) &&
                                                                !isTrialPortalCreation) || formik.values.isVerified}
                                                        sx={{ "&.Mui-disabled": { opacity: 0.5 } }}
                                                    >
                                                        <VerifiedIcon
                                                            fontSize="small"
                                                            className={
                                                                buttonColor === "success" || formik.values.isVerified
                                                                    ? "text-success"
                                                                    : buttonColor === "error"
                                                                        ? "text-danger"
                                                                        : "text-primary"
                                                            }
                                                        />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        )}
                                    </>
                                )}
                            </Box>
                        </Box>

                        {/* Verification Error */}
                        {formik.errors.isVerified && (
                            <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
                                {formik.errors.isVerified}
                            </Typography>
                        )}
                    </Grid>
                )}

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Business Name"
                        name="businessName"
                        value={formik.values.businessName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.businessName && Boolean(formik.errors.businessName)}
                        helperText={formik.touched.businessName && formik.errors.businessName}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        fullWidth
                        options={businessType || []}
                        getOptionLabel={(option) => option?.name || ""}
                        value={businessType?.find((opt) => opt.name === formik.values?.businessType) || null}
                        onChange={(event, value) => formik.setFieldValue("businessType", value?.name)}
                        onBlur={formik.handleBlur}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Business Type"
                                error={formik.touched.businessType && Boolean(formik.errors.businessType)}
                                helperText={formik.touched.businessType && formik.errors.businessType}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        multiline
                        rows={2}
                        fullWidth
                        label="Business Description"
                        name="businessDescription"
                        value={formik.values.businessDescription}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.businessDescription && Boolean(formik.errors.businessDescription)}
                        helperText={formik.touched.businessDescription && formik.errors.businessDescription}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        fullWidth
                        options={countryData || []}
                        getOptionLabel={(option) => option?.name || ""}
                        value={countryData?.find((opt) => opt?.name === formik.values.businessCountry) || null}
                        onChange={(event, value) => {
                            formik.setFieldValue("businessCountry", value?.name);
                            formik.setFieldValue("businessState", "");
                            getBusinessStateDate(value?.name);
                        }}
                        onBlur={formik.handleBlur}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Business Country"
                                error={formik.touched.businessCountry && Boolean(formik.errors.businessCountry)}
                                helperText={formik.touched.businessCountry && formik.errors.businessCountry}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        fullWidth
                        options={businessStateData || []}
                        getOptionLabel={(option) => option?.name || ""}
                        // value={businessStateData?.find((opt) => opt.name === formik.values?.businessState) || null}
                        value={
                            businessStateData?.length
                                ? businessStateData.find(
                                    (opt) => opt.name === formik.values.businessState
                                ) || null
                                : null
                        }
                        // onChange={(event, value) => formik.setFieldValue("businessState", value?.name)}
                        onChange={(event, value) => {
                            formik.setFieldValue("businessState", value?.name || "");
                            formik.setFieldTouched("businessState", true);
                        }}
                        // onBlur={formik.handleBlur}
                        onBlur={() => formik.setFieldTouched("businessState", true)}
                        disabled={!(businessStateData?.length)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Business State"
                                error={formik.touched.businessState && Boolean(formik.errors.businessState)}
                                helperText={formik.touched.businessState && formik.errors.businessState}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Website URL"
                        name="website"
                        value={formik.values.website}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.website && Boolean(formik.errors.website)}
                        helperText={formik.touched.website && formik.errors.website}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Tax ID / Business Registration Number"
                        name="taxId"
                        value={formik.values.taxId}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.taxId && Boolean(formik.errors.taxId)}
                        helperText={formik.touched.taxId && formik.errors.taxId}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        options={dateFormatOptions || []}
                        getOptionLabel={(option) => option.label}
                        value={dateFormatOptions?.find((opt) => opt.value === formik.values.dateFormat) || null}
                        onChange={handleDateFormatChange}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Date Format"
                                fullWidth
                                error={formik.touched.dateFormat && Boolean(formik.errors.dateFormat)}
                                helperText={formik.touched.dateFormat && formik.errors.dateFormat}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        options={Array.isArray(timeZone) ? timeZone : []}
                        getOptionLabel={(option) => option?.timeZone || ""}
                        value={Array.isArray(timeZone) ? timeZone.find((opt) => opt.timeZone === formik.values.timeZone) || null : null}
                        onChange={handleTimeZoneChange}
                        renderOption={(props, option, { index }) => (
                            <li {...props} key={`${option.timeZone}-${index}`}>
                                {option.timeZone}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Time Zone"
                                fullWidth
                                error={formik.touched.timeZone && Boolean(formik.errors.timeZone)}
                                helperText={formik.touched.timeZone && formik.errors.timeZone}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        options={timeFormatOptions || []}
                        getOptionLabel={(option) => option.label}
                        value={timeFormatOptions?.find((opt) => opt.value === formik.values.timeFormat) || null}
                        onChange={handleTimeFormatChange}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Time Format"
                                fullWidth
                                error={formik.touched.timeFormat && Boolean(formik.errors.timeFormat)}
                                helperText={formik.touched.timeFormat && formik.errors.timeFormat}
                            />
                        )}
                    />
                </Grid>

                {(!organizationDataById || isTrialPortalCreation) && (
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Ip Address"
                            name="ipAddress"
                            value={formik.values.ipAddress}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.ipAddress && Boolean(formik.errors.ipAddress)}
                            helperText={formik.touched.ipAddress && formik.errors.ipAddress}
                            disabled={Boolean(organizationDataById) && !isTrialPortalCreation}
                        />
                    </Grid>
                )}

                <Grid item xs={12} sm={6}>
                    <Box sx={{ mt: 2 }}>
                        <label style={{ display: "block", marginBottom: "8px" }}>
                            Active
                        </label>
                        <CustomSwitch
                            name="isActive"
                            checked={formik.values.isActive}
                            onChange={(event) =>
                                formik.setFieldValue("isActive", event.target.checked)
                            }
                        />
                    </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Box sx={{ mt: 2 }}>
                        <label style={{ display: "block", marginBottom: "8px" }}>
                            Enable Auto Invoice
                        </label>
                        <CustomSwitch
                            name="isAutoInvoice"
                            checked={formik.values.isAutoInvoice}
                            onChange={(event) =>
                                formik.setFieldValue("isAutoInvoice", event.target.checked)
                            }
                        />
                    </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" gutterBottom>
                        Image
                    </Typography>

                    <Box
                        component="label"
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.5,
                            p: 2,
                            border: "2px dashed #ccc",
                            borderRadius: 1,
                            backgroundColor: "#fafafa",
                            textAlign: "center",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            "&:hover": {
                                borderColor: "var(--bs-primary)",
                                backgroundColor: "#f0f7ff"
                            }
                        }}
                    >
                        {formik.values.imagePreview ? (
                            <Box sx={{ position: "relative", display: "inline-block" }}>
                                <Avatar
                                    src={formik.values.imagePreview}
                                    sx={{
                                        width: 100,
                                        height: 100,
                                        margin: "0 auto",
                                        border: "2px solid var(--bs-primary)"
                                    }}
                                />

                                <Button
                                    size="small"
                                    variant="contained"
                                    color="error"
                                    startIcon={<DeleteIcon />}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        formik.setFieldValue("organizationLogo", null);
                                        formik.setFieldValue("imagePreview", null);
                                    }}
                                    sx={{ mt: 1 }}
                                >
                                    Remove
                                </Button>
                            </Box>
                        ) : (
                            <Box>
                                <CloudUploadIcon
                                    sx={{ fontSize: 48, color: "var(--bs-primary)", mb: 1 }}
                                />
                                <Typography variant="body2" color="textSecondary">
                                    Click to upload or drag and drop
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                    PNG, JPG, GIF or WebP (Max 5MB)
                                </Typography>
                            </Box>
                        )}

                        <input
                            hidden
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            onBlur={formik.handleBlur}
                        />
                    </Box>

                    {formik.touched.organizationLogo &&
                        formik.errors.organizationLogo && (
                            <Typography
                                variant="caption"
                                color="error"
                                sx={{ mt: 0.5, display: "block" }}
                            >
                                {formik.errors.organizationLogo}
                            </Typography>
                        )}
                </Grid>
            </Grid>
        </>
    );
};

export default OrganizationInfoStep;
